import React from "react";
import LegalPageLayout from "@/components/LegalPageLayout";
import { LEGAL_CONTENT } from "@/data/legalContent";

// Public, unauthenticated route — /about. Includes the Physical Delivery Disclaimer
// (Store Readiness Audit) clarifying that GIFTED is a management interface for physical
// business services fulfilled under the Maison Service Agreement — not a digital-only app.
const About = () => {
  const c = LEGAL_CONTENT.about;
  return <LegalPageLayout topicKey="about" title={c.title} body={c.body} />;
};

export default About;
